import React from 'react';

function MorphingBackground({ current, next, showNext }) {
  return (
    <div className="bg-wrapper">
      {current && (
        <div
          className="bg-layer current"
          style={{ backgroundImage: `url(${current})` }}
        />
      )}
      {next && (
        <div
          className={`bg-layer next ${showNext ? 'visible' : ''}`}
          style={{ backgroundImage: `url(${next})` }}
        />
      )}
    </div>
  );
}

export default MorphingBackground;